import CustomFlagETF from './CustomFlagETF';

export default CustomFlagETF;
